<template>
  <div id="water-fertilizer">
    <div class="water-fertilizer-info">
      <div class="water-fertilizer-title">
        <span class="water-title-text">数&emsp;据&emsp;看&emsp;板</span>
      </div>
      <div class="water-fertilizer-content">
        <div class="water-content-top">
          <div class="water-top-text">
            <span class="water-top-textContainer">环境信息</span>
          </div>
          <div class="water-top-data">
            <div class="water-topData-tem">
              <div class="water-tem-text">
<!--                <div style="width: 40%; height: 100%; display: table">-->
<!--                  <span style="display: table-cell; vertical-align: middle; text-align: right"><img src="../img/ambientTemperature.png"></span>-->
<!--                </div>-->
                <div class="water-temText-div">
                  <span class="water-temText-divContainer">环境温度</span>
                </div>
              </div>
              <div class="water-tem-data">
                <span class="water-tem-dataContainer">-℃</span>
              </div>
            </div>
            <div class="water-topData-hum">
              <div class="water-hum-text">
<!--                <div style="width: 40%; height: 100%; display: table">-->
<!--                  <span style="display: table-cell; vertical-align: middle; text-align: right"><img src="../img/ambientHumidity.png"></span>-->
<!--                </div>-->
                <div class="water-humText-div">
                  <span class="water-humText-divContainer">环境湿度</span>
                </div>
              </div>
              <div class="water-hum-data">
                <span class="water-hum-dataContainer">-%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="water-content-middle">
          <span class="water-middle-text">土壤环境</span>
        </div>
        <div class="water-content-bottom">
          <div class="water-bottom-title">
            <span class="water-bottom-titleContainer">流量状态</span>
          </div>
          <div class="water-bottom-content">
            <div class="water-bottomContent-div">
              <div class="water-bottomContent-text">
                <span class="water-bottom-textContainer">主管道</span>
              </div>
              <div class="water-bottomContent-data">
                <span class="water-bottomContent-dataContainer">-L/小时</span>
              </div>
            </div>

            <div class="water-bottomContent-div">
              <div class="water-bottomContent-text">
                <span class="water-bottom-textContainer">注肥泵1</span>
              </div>
              <div class="water-bottomContent-data">
                <span class="water-bottomContent-dataContainer">-L/小时</span>
              </div>
            </div>

            <div class="water-bottomContent-div">
              <div class="water-bottomContent-text">
                <span class="water-bottom-textContainer">注肥泵2</span>
              </div>
              <div class="water-bottomContent-data">
                <span class="water-bottomContent-dataContainer">-L/小时</span>
              </div>
            </div>

            <div class="water-bottomContent-div">
              <div class="water-bottomContent-text">
                <span class="water-bottom-textContainer">注肥泵3</span>
              </div>
              <div class="water-bottomContent-data">
                <span class="water-bottomContent-dataContainer">-L/小时</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'WaterFertilizerInfo',
    components:{},
    data() {
      return {}
    },

    mounted() {
      this.$message({
        showClose: true,
        type: "warning",
        message: "发送请求失败，请确认设备是否绑定并且在线"
      });
    },
    beforeDestroy() {}
  }
</script>

<style lang="less">
  @import "../less/WaterFertilizarInfo";
</style>



// WEBPACK FOOTER //
// src/components/view/WaterFertilizerInfo.vue